import { api } from "@/api";
import { MutationConfig, MutationResult } from "@/shared/types/base";
import { Ciudad } from "@/shared/types/ciudad";
import { sleep } from "@/shared/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ReactNode } from "react";

export async function deleteCiudad(id: string): Promise<Ciudad> {
    await sleep(1000);
    const response = await api.delete("ciudades/" + id);
    return response.data;
}

export function useDeleteCiudadMutation(id: string, mutationConfig: MutationConfig<Ciudad> = {}) {
    const queryClient = useQueryClient();
    return useMutation({
        ...mutationConfig,
        mutationFn: async () => await deleteCiudad(id),
        onSuccess: (...args) => {
            mutationConfig.onSuccess && mutationConfig.onSuccess(...args);
            queryClient.invalidateQueries({ queryKey: ["ciudades"] });
        },
    });
}

export interface DeleteCiudadMutationProps {
    id: string;
    mutationConfig?: MutationConfig<Ciudad>;
    children?: (mutationResult: MutationResult<Ciudad>) => ReactNode;
}

export function DeleteCiudadMutation({
    id,
    mutationConfig,
    children,
}: DeleteCiudadMutationProps) {
    const mutationResult = useDeleteCiudadMutation(id, mutationConfig);
    return children && children(mutationResult);
}